import { Button, ColorPicker, Drawer, Form, message, Typography } from 'antd'
import React, { useEffect } from 'react'
import useBoolean from '../../../../Utils/useBoolean';
import { useDispatch, useSelector } from 'react-redux';
import FormItem from '../FormItem';
import { addCompaniesInfo, changeCompaniesInfo, fetchCompaniesInfo } from '../../../../Reducers/balance';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';


function hexToInt(input) {
  return parseInt(input.replace(/^#([\da-f])([\da-f])([\da-f])$/i,
    '#$1$1$2$2$3$3').substring(1), 16);
  }

const { Text } = Typography;

const CreateCompanyDrawer = ({ companyId, companyPayload, setCompany }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { value: isOpen, setFalse: close, setTrue: open } = useBoolean(false);

  const companyData = companyPayload?.find(company => company.id === companyId);;

  const openToCreateNewCompany = () => {
    setCompany(null)
    form.resetFields();
    open();
  }

  useEffect(() => {
    if (companyData) {

      const { name, invoiceParams } = companyData;
      // console.log(`BGCL: ${invoiceParams.backgroundColor}`)
      const colorToHex =  "#" + (invoiceParams.backgroundColor & 0x00FFFFFF).toString(16).padStart(6, '0');
      // console.log("BGCLTOHEX", colorToHex)
      const paramsWithColor = { ...invoiceParams, backgroundColor: colorToHex }
      form.setFieldsValue({ name, ...paramsWithColor });
    } else {
      form.resetFields();
    }
  }, [companyId, companyData, form]);

  const handleEditCompany = (data) => {
    // console.log(`COLOR: ${data.backgroundColor}`)

    // const color = form.getFieldValue("backgroundColor")

    // console.log(`COLOR FROM VALUE: ${color}`)

    const colorToHex = hexToInt("#" + data.backgroundColor.toHex())

    
    // console.log(`COLORHEX: ${colorToHex}`)

    const formData = {
      ...(companyId ? { id: companyId } : {}),
      name: data.name,
      invoiceParams: {
        backgroundColor: colorToHex,
        fromName: data.fromName,
        fromLine1: data.fromLine1,
        fromLine2: data.fromLine2,
        fromLine3: data.fromLine3,
        accountHolder: data.accountHolder,
        bank: data.bank,
        iban: data.iban,
        swift: data.swift,
        address: data.address,
      },
    };

    const request = companyId ? changeCompaniesInfo : addCompaniesInfo
    dispatch(request(formData))
      .then(() => {
        message.success(`Successfully ${companyId ? 'edited' : 'created'} company!`);
        dispatch(fetchCompaniesInfo())
        close();
      })
      .catch((err) => {
        message.error(`Failed to ${companyId ? 'edit' : 'create'} company: ${err}`);
      });
  };

  return (
    <div>
      <div className="company_btns">
        {companyId && <Button className="company_btns__btn" onClick={open} icon={<EditOutlined />} />}
        <Button className="company_btns__btn" onClick={openToCreateNewCompany} icon={<PlusOutlined />} />
      </div>
      
      <Drawer
        visible={isOpen}
        title={companyId ? "Edit Company" : "Create Company"}
        closable
        onClose={close}
        width={800}
        placement="right"
      >
        <Form form={form} onFinish={handleEditCompany}>
          <Text strong>Color</Text>
            <Form.Item 
              name="backgroundColor"
              initialValue={null}
              rules={[{ required: true, message: 'color is required!' }]}
              // getValueFromEvent={(color) => {
              //   // console.log("COLOR", color)
              //   console.log("VAL", hexToInt("#" + color.toHex()))
              //   return hexToInt("#" + color.toHex())
              // }}
            >
              <ColorPicker 
                // onChange={(e) => console.log(e)} 
                // defaultValue="#1677ff" 
              />
            </Form.Item>
          <FormItem title="Company short name" attribute="name" placeholder="Company name" />
          <FormItem title="Company name" attribute="fromName" placeholder="Company name" />
          <FormItem title="Address line 1" attribute="fromLine1" placeholder="Address line 1" />
          <FormItem title="Address line 2" attribute="fromLine2" placeholder="Address line 2" />
          <FormItem title="Address line 3" attribute="fromLine3" placeholder="Address line 3" />
          <FormItem title="Account holder" attribute="accountHolder" placeholder="Account holder" />
          <FormItem title="SWIFT" attribute="swift" placeholder="SWIFT" />
          <FormItem title="Address" attribute="address" placeholder="Address" />
          <FormItem title="IBAN" attribute="iban" placeholder="IBAN" />
          <FormItem title="Bank" attribute="bank" placeholder="Bank" />
          <Button type="primary" htmlType="submit">
            {companyId ? "Save Changes" : "Create Company"}
          </Button>
        </Form>
      </Drawer>
    </div>
  );
};

export default CreateCompanyDrawer;
